import React, { useEffect, useState } from "react";
import axios from "axios";
import { apiKey } from "../../config/config";

export default function CustomerReports({ lang = {} }) {
  const [report, setReport] = useState(null);
  const [contracts, setContracts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const session = JSON.parse(sessionStorage.getItem("aman-customer") || "{}");
    const token = session.token;
    if (!token) return;

    const headers = { Authorization: `Bearer ${token}` };

    axios
      .get(`${apiKey}/customer-panel/reports`, { headers })
      .then((res) => setReport(res.data.report))
      .catch((err) => console.error(err));

    axios
      .get(`${apiKey}/customer-panel/contracts`, { headers })
      .then((res) => {
        setContracts(res.data.contracts || []);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  }, []);

  return (
    <div className="container-fluid px-4 py-3">
      <div className="pagetitle mb-4">
        <h1 className="fw-bold">{lang.Reports || "Customer Financial Reports"}</h1>
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">Home</li>
            <li className="breadcrumb-item active">Financial Reports</li>
          </ol>
        </nav>
      </div>

      {/* Summary Stat Cards */}
      <div className="row g-3 mb-4">
        <div className="col-md-3">
          <div className="card shadow-sm border-0 rounded-3 p-3 bg-white">
            <span className="small text-muted fw-bold">TOTAL CONTRACTS</span>
            <h3 className="fw-bold text-dark mb-0 mt-1">{report?.total_contracts || 0}</h3>
          </div>
        </div>
        <div className="col-md-3">
          <div className="card shadow-sm border-0 rounded-3 p-3 bg-white">
            <span className="small text-muted fw-bold">ACTIVE CONTRACTS</span>
            <h3 className="fw-bold text-success mb-0 mt-1">{report?.active_contracts || 0}</h3>
          </div>
        </div>
        <div className="col-md-3">
          <div className="card shadow-sm border-0 rounded-3 p-3 bg-white">
            <span className="small text-muted fw-bold">COMPLETED CONTRACTS</span>
            <h3 className="fw-bold text-primary mb-0 mt-1">{report?.completed_contracts || 0}</h3>
          </div>
        </div>
        <div className="col-md-3">
          <div className="card shadow-sm border-0 rounded-3 p-3 bg-white">
            <span className="small text-muted fw-bold">OUTSTANDING BALANCE</span>
            <h3 className="fw-bold text-danger mb-0 mt-1">
              SAR {report?.remaining_balance ? Number(report.remaining_balance).toLocaleString() : 0}
            </h3>
          </div>
        </div>
      </div>

      {/* Breakdown Report Table */}
      <div className="card shadow-sm border-0 rounded-3">
        <div className="card-header bg-white py-3">
          <h5 className="fw-bold m-0 text-dark">Contract Financial Summary Report</h5>
        </div>
        <div className="card-body p-0">
          <div className="table-responsive">
            <table className="table table-hover align-middle mb-0">
              <thead className="table-light">
                <tr>
                  <th>Contract ID</th>
                  <th>Branch</th>
                  <th>Contract Date</th>
                  <th>Total Value</th>
                  <th>Total Paid</th>
                  <th>Remaining</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="7" className="text-center py-4">Loading reports...</td>
                  </tr>
                ) : contracts.length === 0 ? (
                  <tr>
                    <td colSpan="7" className="text-center py-4 text-muted">No contracts available.</td>
                  </tr>
                ) : (
                  contracts.map((item) => {
                    const total = Number(item.total_value || 0);
                    const paid = Number(item.total_paid || 0);
                    const rem = Math.max(0, total - paid);

                    return (
                      <tr key={item.id}>
                        <td className="fw-bold">#{item.id}</td>
                        <td>{item.branch_name || "Main Branch"}</td>
                        <td>{item.date_contract ? new Date(item.date_contract).toLocaleDateString() : "N/A"}</td>
                        <td className="fw-bold">SAR {total.toLocaleString()}</td>
                        <td className="text-success fw-bold">SAR {paid.toLocaleString()}</td>
                        <td className="text-danger fw-bold">SAR {rem.toLocaleString()}</td>
                        <td>
                          <span className={`badge ${item.status === 1 ? "bg-success" : item.status === 2 ? "bg-primary" : "bg-secondary"}`}>
                            {item.status === 1 ? "Active" : item.status === 2 ? "Completed" : "Closed"}
                          </span>
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
